import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useInstance, onBeforeUpdate } from 'intact-vue';
import { EMPTY_OBJ, isNullOrUndefined } from 'intact-shared';
export function useFilter(getNodes, getExpandedKeys) {
  var instance = useInstance();
  instance.on('$receive:filter', refresh);
  onBeforeUpdate(function (lastVNode, nextVNode) {
    var lastProps = lastVNode.props || EMPTY_OBJ;
    var nextProps = nextVNode.props || EMPTY_OBJ;
    if (lastProps === nextProps || isNullOrUndefined(_filterInstanceProperty(lastProps)) && isNullOrUndefined(_filterInstanceProperty(nextProps))) return;
    if (_filterInstanceProperty(lastProps) === _filterInstanceProperty(nextProps)) {
      refresh();
    }
  });
  function refresh() {
    var nodes = getNodes();
    var _instance$get = instance.get(),
      filter = _filterInstanceProperty(_instance$get);
    var loop = function loop(nodes) {
      nodes.forEach(function (node) {
        if (filter) {
          if (filter(node.data, node)) {
            node.filter = true;
            updateFilterUpward(node.parent);
          } else {
            node.filter = false;
          }
        } else {
          node.filter = true;
        }
        if (node.children) {
          loop(node.children);
        }
      });
    };
    loop(getNodes());
  }
  function updateFilterUpward(node) {
    if (!node || _filterInstanceProperty(node)) return;
    // should expand the node 
    getExpandedKeys().add(node.key);
    node.filter = true;
    updateFilterUpward(node.parent);
  }
}